import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { PERMISSIONS_API_PATH } from "@/modules/Permissions/constants";
import { AGENT_SUB_ROLES } from "@/core/enums/AGENT_SUB_ROLES";
import { formatString } from "@/core/utils/helpers";

class PermissionsService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public getAll(agentType: AGENT_SUB_ROLES): Promise<ICoreResponse> {
    return this.restClient.get(
      formatString(PERMISSIONS_API_PATH.GET_ALL, agentType),
    );
  }
}

export default PermissionsService;
